import { get } from '@client/lib/request';
import { CustomerData } from '@shared/types/customer';

const customer = (path: string) => `/api/phoenix/customer/${path}`;

// TODO: Fix typing.
export const getCustomer = async (): Promise<CustomerData> => {
    const data = await get(customer('me'));

    // For testing purposes you can mock Plus member.
    // data.plus_status = {
    //     ...(data.plus_status || {}),
    //     member: true,
    // };

    return data;
};

/**
 * In DOI countries users should confirm the email.
 * The registration already sends the confirmation email,
 * this function is for when we need to resend it for some reason.
 */
export const sendConfirmationEmail = () => get(customer('requestConfirmationMail'));
